import { Loading } from './loading';

export default {
  tag: 'loading',
  format: `<loading content="xxx"></loading>`,
  sourcePipeline: (source: string) => source,
  componentFn: (node: any) => {
    const content = node?.content as string | undefined;
    return <Loading content={content} />;
  },
};
